<template>
    <div>
      <span v-for="(k,i) in keys" :key="i" class="caption">
          <span :class="`${regdata[k]?'success--text':'warning--text'} mr-1`">{{k.toUpperCase()}}</span>
      </span>
    </div>
</template>

<script>
  export default {
    props:['keys','regdata'],
    components: {},
    name: "RegData",
    data() {
      return {}
    },
    mounted() {
    },
    methods: {}
  }
</script>

<style scoped>

</style>